import React from "react";
import { RegisterForm } from "../components";

const RegisterContainer = () => {
  return (
    <div className="col-xs-6 col-xs-push-3">
      <RegisterForm />
    </div>
  );
};

export default RegisterContainer;
